import _ from 'underscore';
import { Component } from 'react';
import propTypes from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { PreviewDrawer } from '~/features/common';
import isFeatureEnabled from '~/components/common/is-feature-enabled';
import { apiPut, showLoader, hideLoader, handleApiError, getDescendantIdsFromFolder } from '../../../common';
import AssetPickerCreateAssetDropdown from './create-assets/asset-picker-create-asset-dropdown';
import AssetPickerFolder from './asset-picker-folder';
import AssetPickerSearchBar, { AcademyAssetPickerSearchBar } from './asset-picker-search-bar';
import AssetPickerTypes from './asset-picker-types';

class AssetPicker extends Component {
  constructor(props, context) {
    super(props, context);
    // TODO currentAsset can be an array. Add proptypes?
    const openAsset = props.currentAsset;

    this.state = {
      expandedFolderIds: openAsset ? this.assetFolderPath(openAsset) : [],
    };
  }

  componentDidMount() {
    if (this.props.isEditable) {
      this.makeSortable();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.expandableFolderIds !== this.props.expandableFolderIds) {
      this.setState({ expandedFolderIds: this.assetFolderPath(this.props.expandableFolderIds) });
    }
  }

  render() {
    const me = this;

    const sortedRootFolders = _.sortBy(this.props.rootFolders, (folder) => folder.order);

    let createButton;
    if (this.props.isEditable && this.props.isRootEditable)
      createButton = (
        <AssetPickerCreateAssetDropdown itemFolderId={undefined} updateCallback={this.props.updateCallback} />
      );

    const isActiveById = this.isActiveByid();

    // Default to selectable assets if searchable assets is not provided
    let validSearchTypes = this.props.searchableAssets;
    if (!validSearchTypes) {
      validSearchTypes = this.props.selectableAssets ? Object.keys(this.props.selectableAssets) : null;
    }

    return (
      <PreviewDrawer>
        <div className="asset-picker-wrapper">
          {this.props.showSearchBar && isFeatureEnabled('asset_picker_search_bar') && (
            <div className="asset-picker-search">
              {this.props.searchBarForAcademy && (
                <AcademyAssetPickerSearchBar
                  includeUnpublishedTrainings={this.props.includeUnpublishedTrainings}
                  onItemSelect={me.handleItemSelect}
                  onFolderSelect={me.handleFolderSelect}
                  validSearchTypes={validSearchTypes}
                />
              )}
              {!this.props.searchBarForAcademy && (
                <AssetPickerSearchBar
                  includeUnpublishedTrainings={this.props.includeUnpublishedTrainings}
                  onItemSelect={me.handleItemSelect}
                  onFolderSelect={me.handleFolderSelect}
                  validSearchTypes={validSearchTypes}
                  onlyVisible={this.props.onlyVisible}
                />
              )}
            </div>
          )}
          <ul ref={(assetPicker) => (this.assetPicker = assetPicker)} className="asset-picker js-asset-picker-sortable">
            {_.map(sortedRootFolders, (rootFolder) => (
              <AssetPickerFolder
                key={`item-folder-${rootFolder.id}`}
                currentAsset={me.props.currentAsset}
                expandedFolderIds={me.state.expandedFolderIds}
                folder={rootFolder}
                isActive={isActiveById[rootFolder.id]}
                isActiveById={isActiveById}
                isEditable={me.props.isEditable}
                itemMoveCallback={me.handleItemMove}
                selectableAssets={me.props.selectableAssets}
                setExpanded={(id, expanded) => me.setExpandedFolder(id, expanded)}
                parentEditors={[]}
                updateCallback={me.props.updateCallback}
                viewableAssets={me.props.viewableAssets}
                refreshSortable={(draggable) => me.refreshSortable(draggable)}
                assetsAreLinks={me.props.assetsAreLinks}
                excludedAssetIds={me.props.excludedAssetIds}
              />
            ))}
            {this.props.children}
          </ul>
          {createButton}
          {this.props.isEditable && (
            <ReactTooltip positionStrategy="fixed" id="asset-picker" place="bottom" effect="solid" />
          )}
        </div>
      </PreviewDrawer>
    );
  }

  isActiveByid = () => {
    const isActiveById = {};
    const { currentAsset } = this.props;
    if (currentAsset) {
      if (Array.isArray(currentAsset)) {
        _.each(currentAsset, (asset) => {
          isActiveById[asset.id] = true;
        });
      } else {
        isActiveById[currentAsset.id] = true;
      }
    }

    return isActiveById;
  };

  makeSortable = () => {
    const me = this;

    $(this.assetPicker).sortable({
      forcePlaceholderSize: true,
      placeholder: 'course-box-section-placeholder',
      distance: '5',
      handle: '.allow-draggable',
      connectWith: '.js-asset-picker-sortable',
      containment: '.admin-guide-viewer-pane',
      scrollSpeed: 5,
      scrollSensitivity: 100,
      stop(event, ui) {
        me.handleItemMove(event, ui, this);
      },
    });
  };

  refreshSortable(draggable) {
    setTimeout(() => $(this.assetPicker).sortable('refresh'));
    setTimeout(() => $(draggable.parent()).sortable('refresh'));
  }

  setExpandedFolder = (id, expanded) => {
    const expandedFolderIds = this.state.expandedFolderIds.concat([]);
    const currentlyExpanded = this.state.expandedFolderIds.includes(id);

    if (!expanded && currentlyExpanded) {
      expandedFolderIds.splice(expandedFolderIds.indexOf(id), 1);
    }

    if (expanded && !currentlyExpanded) {
      expandedFolderIds.push(id);
    }

    this.setState({ expandedFolderIds });
  };

  // TODO: Refactor/Clean this up
  handleItemMove = (event, ui, sortNode) => {
    const me = this;

    const $asset = $(ui.item);
    const id = $asset.attr('data-id');
    const type = $asset.attr('data-type');
    const originalParentId = $asset.attr('data-parent-id');

    const $folder = $asset.parent().closest('.asset-picker-folder');
    let newParentId = $folder.attr('data-id');

    if (type === AssetPickerTypes.FOLDER || newParentId) {
      newParentId = newParentId || 'root';

      const prevOrder = parseFloat($asset.prev().attr('data-order'));
      const nextOrder = parseFloat($asset.next().attr('data-order'));
      let newOrder = 1;

      if (prevOrder && nextOrder) {
        newOrder = (prevOrder + nextOrder) / 2;
      } else if (prevOrder) {
        newOrder = prevOrder + 1;
      } else if (nextOrder) {
        newOrder = nextOrder / 2;
      }

      const data = {
        ui_order: newOrder,
        item_folder_id: newParentId,
      };

      const url = AssetPickerTypes.getUpdateItemUrl({ id, type });

      let shouldMove = true;
      if (type === AssetPickerTypes.CLASS && originalParentId != newParentId) {
        shouldMove = confirm(
          'All instructors for this event will be added as editors to this ' +
            'folder - are you sure you want to move.',
        );
      }
      if (shouldMove) {
        showLoader();
        apiPut(
          url,
          data,
          () => {
            hideLoader();
            me.props.updateCallback(() => {
              $(sortNode).sortable('cancel');
            });
          },
          handleApiError(() => {
            $(sortNode).sortable('cancel');
          }),
        );
      }
    } else {
      alert('Cannot move an item outside of a folder.');
      $(sortNode).sortable('cancel');
    }
  };

  assetFolderPath = (asset, folders, path) => {
    folders = folders || this.props.rootFolders;
    path = path || [];
    if (Array.isArray(asset)) {
      for (let i = 0; i < asset.length; i++) {
        const singleAsset = asset[i];
        this.getFolderPathForAsset(singleAsset, folders, path);
      }
    } else {
      this.getFolderPathForAsset(asset, folders, path);
    }
    return path;
  };

  getFolderPathForAsset = (asset, folders, path) => {
    for (let i = 0; i < folders.length; i++) {
      if (getDescendantIdsFromFolder(folders[i]).includes(asset.id)) {
        path.push(folders[i].id);
        this.assetFolderPath(asset, folders[i].subfolders, path);
        break;
      }
    }
  };

  getItemsFromFolderPath = (path) => {
    const { rootFolders } = this.props;

    let items = [];
    let currFolders = rootFolders;
    path.forEach((folderPathId, index) => {
      const isLastFolder = index === path.length - 1;
      currFolders.forEach((folder) => {
        if (folder.id === folderPathId) {
          if (isLastFolder) {
            // Concat all content
            items = [
              ...(folder.challenges ?? []),
              ...(folder.courses ?? []),
              ...(folder.resources ?? []),
              ...(folder.topLevelContents ?? []),
              ...(folder.trainingClasses ?? []),
              ...(folder.trainingSeries ?? []),
              ...(folder.trainingWorkflows ?? []),
              ...(folder.universities ?? []),
              ...(folder.academyCertifications ?? []),
              ...(folder.academyPaths ?? []),
              ...(folder.academyCollections ?? []),
              ...(folder.academyCollectionContents ?? []),
              ...(folder.academyEvents ?? []),
            ];
          } else {
            currFolders = folder.subfolders;
          }
        }
      });
    });

    return items;
  };

  handleItemSelect = (item) => {
    const folderPathIds = this.assetFolderPath(item.searchResult);
    const folderItems = this.getItemsFromFolderPath(folderPathIds);

    // Use the id returned from search to find the data in the folder tree
    // This avoids some inconsistencies between the search result data and the folder tree data
    const folderItem = folderItems.find(({ id }) => id === item.searchResult?.id);

    // If item is a Challenge found through the search results but no folderItem is found,
    // it is an unassignable Challenge.
    if (!this.props.includeUnassignableChallenges && item.searchResult?.type === 'challenge' && !folderItem) {
      // eslint-disable-next-line no-alert
      alert('This Challenge is not assignable. Make sure it has scorecard questions before selecting it.');
      return;
    }

    // Check if item has already been selected
    let isSelected = false;
    if (Array.isArray(this.props.currentAsset)) {
      for (const asset of this.props.currentAsset) {
        if (asset.id === folderItem?.id) {
          isSelected = true;
        }
      }
    } else if (this.props.currentAsset?.id === folderItem?.id) {
      isSelected = true;
    }

    // Check if search result is a selectable asset before selecting
    // Do not unselect an already selected item
    const callback = this.props.selectableAssets[folderItem?.type];
    if (typeof callback === 'function' && !isSelected) {
      callback(folderItem);
    }

    // Open folders if not already open
    const foldersToExpand = [...this.state.expandedFolderIds];
    for (const folderId of folderPathIds) {
      if (!foldersToExpand.includes(folderId)) {
        foldersToExpand.push(folderId);
      }
    }

    this.setState({ expandedFolderIds: foldersToExpand });
  };

  handleFolderSelect = (folder) => {
    // Open folder if not already open
    if (!this.state.expandedFolderIds.includes(folder.id)) {
      this.setState({ expandedFolderIds: [...this.state.expandedFolderIds, folder.id] });
    }
  };
}

AssetPicker.defaultProps = {
  viewableAssets: [AssetPickerTypes.FOLDER],
  selectableAssets: {},
  showSearchBar: false,
  searchBarForAcademy: false,
  updateCallback: () => {},
};

AssetPicker.propTypes = {
  isEditable: propTypes.bool,
  isRootEditable: propTypes.bool,
  assetsAreLinks: propTypes.bool,
  showSearchBar: propTypes.bool,
  searchBarForAcademy: propTypes.bool,
  updateCallback: propTypes.func,
  viewableAssets: propTypes.arrayOf(propTypes.string).isRequired,
  selectableAssets: propTypes.objectOf(propTypes.func).isRequired,
  searchableAssets: propTypes.arrayOf(propTypes.string),
  expandableFolderIds: propTypes.oneOfType([
    propTypes.shape({
      id: propTypes.string.isRequired,
    }),
    propTypes.array,
  ]),
  rootFolders: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.string.isRequired,
      order: propTypes.number.isRequired,
    }),
  ).isRequired,
  currentAsset: propTypes.oneOfType([
    propTypes.shape({
      id: propTypes.string.isRequired,
    }),
    propTypes.array,
  ]),
  children: propTypes.node,
  includeUnpublishedTrainings: propTypes.bool,
  includeUnassignableChallenges: propTypes.bool,
  onlyVisible: propTypes.bool,
  excludedAssetIds: propTypes.arrayOf(propTypes.string),
};

export default AssetPicker;
